/** Calculate the average of an array of numbers.
 *
 */
export const calculateAverage = (stats) => {
  if (!stats || !stats.length) {
    return 0;
  }

  let sum = 0;
  let count = 0;
  for (var n = 0; n < stats.length; ++n) {
    if (stats[n]) {
      sum += stats[n];
      count++;
    }
  }

  return count !== 0 ? sum / count : 0;
};

/** Find the lowest amount in an array of numbers.
 *
 */
export const calculateMinimum = (stats) => {
  if (!stats || !stats.length) {
    return 0;
  }

  let min = stats[0];
  for (var n = 0; n < stats.length; ++n) {
    if (stats[n] < min) min = stats[n];
  }
  return min;
};

/** Find the maximum amount in an array of numbers.
 *
 */
export const calculateMaximum = (stats) => {
  if (!stats || !stats.length) {
    return 0;
  }

  let max = stats[0];
  for (var n = 0; n < stats.length; ++n) {
    if (stats[n] > max) max = stats[n];
  }
  return max;
};
